module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-1-500467fb248439a48a3fce6999c4262a.jpg";